const VIRTUAL_PAGES = {
  click: { virtualPage: "/metrics/click/", virtualTitle: "!#[Клик по]: " },
  scroll: { virtualPage: "/metrics/scroll/", virtualTitle: "!#[Скролл до]: " },
  popup: { virtualPage: "/metrics/popup/", virtualTitle: "!#[Открытие popup]: " },
  images: { virtualPage: "/metrics/images/", virtualTitle: "!#[Увеличение изображения]: " },
  iframe: { virtualPage: "/metrics/iframe/", virtualTitle: "!#[Просмотрен iframe]: " },
};

export { VIRTUAL_PAGES };
